import * as requestFromServer from './productsCrud';
import { productsSlice, callTypes } from './productsSlice';

const { actions } = productsSlice;

export const fetchProducts = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findProducts(queryParams)
    .then((response) => {
      //console.log('productsAction: fetchProducts ...');
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          const { totalCount, entities } = {
            totalCount: response.data.data.totalCount,
            entities: response.data.data.list,
          };
          dispatch(actions.productsFetched({ totalCount, entities }));
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.list }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find products";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchProduct = (productCode) => (dispatch) => {
  if (!productCode) {
    return dispatch(actions.productFetched({ productForView: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getProduct(productCode)
    .then((response) => {
      console.log('fetchProduct', response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          //console.log(response.data.data);
          dispatch(
            actions.productFetched({ productForView: response.data.data })
          );
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find product";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createProduct = (product) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createProduct(product)
    .then((response) => {
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(
            actions.productFetched({ productForView: response.data.data })
          );
          dispatch(
            actions.sendMsg({
              msg: 'Амжилттай хадгаллаа!',
              callType: callTypes.action,
            })
          );
          break;
        default:
          var error = response.data.msg.desc;
          //console.log('createProduct err', error);
          dispatch(actions.catchError({ error, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't create product";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateProduct = (productForView) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateProduct(productForView)
    .then((response) => {
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(
            actions.productUpdated({ productForView: response.data.data })
          );
          dispatch(
            actions.sendMsg({
              msg: 'Амжилттай хадгаллаа!',
              callType: callTypes.action,
            })
          );
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't update product";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteProduct = (productCode) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteProduct(productCode)
    .then((response) => {
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.productDeleted({ productCode }));

          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't close product";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const clearProduct = () => (dispatch) => {
  dispatch(actions.productCleared());
};
